/**
 * Centralized typed access to Vite env. Throws early in dev when a required value is missing
 * so we never fall back to a misconfigured runtime.
 */
function readEnv(key: string): string | undefined {
  const value = import.meta.env[key];
  if (typeof value !== 'string' || value.length === 0) return undefined;
  return value;
}

function requireEnv(key: string): string {
  const value = readEnv(key);
  if (value === undefined) {
    throw new Error(
      `Missing required env var ${key}. Copy apps/web/.env.example to .env.local and fill it in.`,
    );
  }
  return value;
}

export const env = {
  apiBaseUrl: requireEnv('VITE_API_BASE_URL'),
  assetsCdnBaseUrl: readEnv('VITE_ASSETS_CDN_BASE_URL'),
  cognito: {
    userPoolId: readEnv('VITE_COGNITO_USER_POOL_ID'),
    userPoolClientId: readEnv('VITE_COGNITO_USER_POOL_CLIENT_ID'),
    domain: readEnv('VITE_COGNITO_DOMAIN'),
    redirectSignIn: readEnv('VITE_COGNITO_REDIRECT_SIGN_IN'),
    redirectSignOut: readEnv('VITE_COGNITO_REDIRECT_SIGN_OUT'),
  },
} as const;

export function isCognitoConfigured(): boolean {
  const c = env.cognito;
  return Boolean(
    c.userPoolId && c.userPoolClientId && c.domain && c.redirectSignIn && c.redirectSignOut,
  );
}
